import React, { useContext } from 'react';

import { Collapse, List } from '@atom/mui';
import { MediaFolderTree } from '@atom/types/media';

import FolderTreeContext from './FolderTreeContext';
import FolderTreeItem from './FolderTreeItem';

type FolderTreeListProps = {
  trees: MediaFolderTree[];
  level: number;
  ancestors: string[];
};

const FolderTreeList = ({ trees, level, ancestors }: FolderTreeListProps) => {
  const { expandedIds } = useContext(FolderTreeContext);

  return (
    <List disablePadding>
      {trees.map(tree => {
        const nextAncestors = [...ancestors, tree.id];

        return (
          <React.Fragment key={tree.id}>
            <FolderTreeItem
              tree={tree}
              level={level}
              ancestors={nextAncestors}
            />
            {tree.children && (
              <Collapse
                in={expandedIds.has(tree.id)}
                timeout="auto"
                unmountOnExit
              >
                <FolderTreeList
                  trees={tree.children}
                  level={level + 1}
                  ancestors={nextAncestors}
                />
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
    </List>
  );
};

export default FolderTreeList;
